import format from 'date-fns/format'
import isValidDate from '@utils/is-valid-date'

export default function formatDate(date) {
  if(!isValidDate(date)) return false
  return format(date, ['d MMMM'])
}
